module.exports = __webpack_public_path__ + "static/media/closeSidebar.e1046f0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/closeSidebar.svg
// module id = 176
// module chunks = 0